import React from 'react';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { alpha, styled } from '@mui/material/styles';
import { ChipGroup } from 'components/ChipGroup';
import { useTranslation } from 'react-i18next';
import { useZoomControl } from 'features/content-zoom/hooks/useZoomControl';
import { SxProps } from '@mui/material';
import { useBreakpoints } from 'hooks/useBreakpoints';

const Root = styled(ChipGroup)(({ theme }) => ({
  position: 'relative',
  gap: theme.spacing(1),
  height: 32,
  borderRadius: 32 / 2,
  backgroundColor: alpha(theme.palette.common.black, 0.6),
  overflow: 'hidden',
  pointerEvents: 'auto',
}));

const StyledGridPanelControl = styled(GridPanelControl)({
  border: 'none',
});

const controlSx: SxProps = {
  backgroundColor: 'transparent',
};

export const ZoomControls = () => {
  const { t } = useTranslation('room');

  const { isMobile } = useBreakpoints();

  const { handleZoomIn, handleZoomOut, handleReset, disabled, visible } = useZoomControl();

  if (!visible) {
    return null;
  }

  return (
    <Root className={!isMobile ? 'hover-child' : ''}>
      <StyledGridPanelControl
        icon="arrows-zoom-out"
        onClick={handleReset}
        tooltip={t('tooltips.content_zoom.reset_zoom')}
        sx={controlSx}
      />

      <StyledGridPanelControl
        icon="minus"
        onClick={handleZoomOut}
        disabled={disabled.zoomOut}
        tooltip={disabled.zoomOut ? '' : t('tooltips.content_zoom.zoom_out')}
        sx={controlSx}
      />

      <StyledGridPanelControl
        icon="add"
        onClick={handleZoomIn}
        disabled={disabled.zoomIn}
        tooltip={disabled.zoomIn ? '' : t('tooltips.content_zoom.zoom_in')}
        sx={controlSx}
      />
    </Root>
  );
};
